import { requests } from "../../API/Api";
import { IGetThreePsCodeListPayload, ISaveThreePsCodePayload } from "./threePsCodes.model";

const GetThreePsVendorList = {
    get: () => requests.get("/api/ThreePsCode/get-three-ps-vendor"), 
};

const GetThreePsCodeList = {
    post: (payload: IGetThreePsCodeListPayload) => requests.post("/api/ThreePsCode/get-three-ps-code", payload),
};

const SaveThreePsCode = {
    post: (payload: ISaveThreePsCodePayload[]) => requests.post("/api/ThreePsCode/save-three-ps-code-data", payload),
};

const threePsCodesApi = {
    GetThreePsVendorList,
    GetThreePsCodeList,
    SaveThreePsCode,
}

export default threePsCodesApi;